import axios from '../helpers/axios';
import { logError } from '../services';
import {
  IBuildPhasePhoto,
  IBuildPhasePhotosQueryParams,
  IBuildMessages,
  IBuildMessagesQueryParams
} from '../models/phases-of-contruction';
import { IResponse } from '../models/util';

const baseUrl = '/api/builds';

export const getBuildPhasePhotos = async (
  buildId: string | number,
  params?: IBuildPhasePhotosQueryParams
): Promise<IResponse<IBuildPhasePhoto>> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${buildId}/photos`, {
      params
    });
    return data;
  } catch (error) {
    logError(error, 'getBuildPhasePhotos failed');
    return Promise.reject(error);
  }
};

export const getBuildMessages = async (
  buildId: string | number,
  params?: IBuildMessagesQueryParams
): Promise<IResponse<IBuildMessages[]>> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${buildId}/messages`, {
      params
    });
    return data;
  } catch (error) {
    logError(error, 'getBuildMessages failed');
    return Promise.reject(error);
  }
};

export const addBuildMessage = async (buildId: number, formData: FormData): Promise<void> => {
  try {
    await axios.post(`${baseUrl}/${buildId}/messages`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  } catch (error) {
    logError(error, 'postBuildCommunicationMessage failed');
    return Promise.reject(error);
  }
};
